import * as tslib_1 from "tslib";
import React from 'react';
import SelectableComponent from '../components/SelectableComponent';
import SelectableContentLayout from '../components/SelectableContentLayout';
var KEY_CODE_ENTER = 13;
var KEY_CODE_DOWN = 40;
var SelectableContainer = /** @class */ (function (_super) {
    tslib_1.__extends(SelectableContainer, _super);
    function SelectableContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onModalChange = function (event, value) {
            if (_this.props.onChange) {
                _this.props.onChange(event, value);
            }
            if (_this.props.onBlur) {
                _this.props.onBlur(value);
            }
        };
        _this.state = {
            focused: false,
            showModal: false,
        };
        _this.onPopRef = _this.onPopRef.bind(_this);
        _this.onIconClick = _this.onIconClick.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
        _this.hidePop = _this.hidePop.bind(_this);
        _this.renderPop = _this.renderPop.bind(_this);
        _this.renderContent = _this.renderContent.bind(_this);
        _this.renderModal = _this.renderModal.bind(_this);
        return _this;
    }
    SelectableContainer.prototype.componentWillUnmount = function () {
        clearTimeout(this.blurTimer);
    };
    SelectableContainer.prototype.showPop = function () {
        if (this.props.readOnly || this.props.disabled) {
            return;
        }
        if (this.pop) {
            this.pop.open();
        }
        if (!this.props.usePop && !this.state.showModal) {
            this.setState({
                showModal: true,
            });
        }
        if (this.props.onOpen) {
            this.props.onOpen();
        }
    };
    SelectableContainer.prototype.hidePop = function () {
        if (this.pop) {
            this.pop.close();
        }
        if (!this.props.usePop) {
            this.setState({
                showModal: false,
            });
        }
    };
    /**
     * 渲染弹出框内容
     */
    SelectableContainer.prototype.renderPop = function () {
        var _this = this;
        if (this.props.readOnly || this.props.disabled) {
            return;
        }
        return this.props.popRender({
            open: this.showPop,
            close: this.hidePop,
            value: this.props.value,
            onChange: function (event, value) {
                _this.props.onChange(event, value);
                if (_this.props.onBlur) {
                    _this.props.onBlur(event);
                }
            },
            todayBeforeForbidden: this.props.todayBeforeForbidden,
            onlyYearMonth: this.props.onlyYearMonth,
        });
    };
    SelectableContainer.prototype.renderModal = function () {
        if (this.props.readOnly || this.props.disabled) {
            return;
        }
        return this.props.modalRender({
            open: this.showPop,
            close: this.hidePop,
            value: this.props.value,
            onChange: this.onModalChange,
        });
    };
    /**
     * 渲染内容区域
     */
    SelectableContainer.prototype.renderContent = function () {
        return this.props.contentRender({
            value: this.props.value,
            onChange: this.props.onChange,
            pre: this.props.pre,
        });
    };
    SelectableContainer.prototype.onPopRef = function (pop) {
        this.pop = pop;
    };
    SelectableContainer.prototype.onIconClick = function (event) {
        if (this.props.popWhenIconClick) {
            event.stopPropagation();
            this.showPop();
        }
    };
    SelectableContainer.prototype.onClick = function (event) {
        if (!this.props.propagation) {
            event.stopPropagation();
        }
        if (!this.props.popWhenIconClick) {
            this.showPop();
        }
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    SelectableContainer.prototype.onInputChange = function (event) {
        if (this.props.onChange) {
            this.props.onChange(event, event.target.value);
        }
    };
    SelectableContainer.prototype.onInputKeyDown = function (event) {
        if (!this.props.usePop) {
            return;
        }
        if (event.keyCode === KEY_CODE_ENTER) {
            this.hidePop();
        }
        else if (event.keyCode === KEY_CODE_DOWN) {
            this.showPop();
        }
    };
    SelectableContainer.prototype.onFocus = function (event) {
        this.setState({
            focused: true,
        });
        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    };
    SelectableContainer.prototype.onBlur = function (event) {
        var _this = this;
        event.persist();
        this.blurTimer = setTimeout(function () {
            _this.setState({
                focused: false,
            });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
            // tslint:disable-next-line:no-any
        }, 200);
    };
    SelectableContainer.prototype.render = function () {
        return (React.createElement(SelectableComponent, tslib_1.__assign({}, this.props, { focused: this.state.focused, popRender: this.renderPop, modalRender: this.renderModal, showModal: this.state.showModal, contentRender: this.renderContent, popRef: this.onPopRef, onFocus: this.onFocus, onBlur: this.onBlur, onChange: this.onInputChange, onInputKeyDown: this.onInputKeyDown, onClick: this.onClick, onIconClick: this.onIconClick, propagation: this.props.propagation, name: this.props.name })));
    };
    SelectableContainer.defaultProps = {
        usePop: true,
        width: '100%',
        contentRender: function (_a) {
            var value = _a.value, pre = _a.pre;
            return (React.createElement(SelectableContentLayout, { pre: pre }, value));
        },
    };
    return SelectableContainer;
}(React.PureComponent));
export default SelectableContainer;
//# sourceMappingURL=SelectableContainer.js.map